// src/components/BasemapGalleryWidget.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const BasemapGalleryWidget = ({ view }) => {
  useEffect(() => {
    if (!view || !view.ui) return;

    let basemapGallery, expandWidget;

    loadModules([
      'esri/widgets/BasemapGallery',
      'esri/widgets/Expand'
    ]).then(([BasemapGallery, Expand]) => {
      basemapGallery = new BasemapGallery({
        view
      });

      expandWidget = new Expand({
        expandTooltip: "Basemaps",
        view,
        content: basemapGallery,
        expandIconClass: 'esri-icon-basemap',
        expanded: false
      });

      view.ui.add(expandWidget, {position: 'top-left', index: 1});
    });

    return () => {
      if (expandWidget && view?.ui) {
        view.ui.remove(expandWidget);
        expandWidget.destroy();
      }
      if (view?.map && basemapGallery) {
        basemapGallery.destroy();
      }
    };
  }, [view]);

  return null;
};

export default BasemapGalleryWidget;
